import * as Preact from "preact"

import App from "@frog/source/models/App.js"
import Zone from "@frog/source/models/Zone.js"
// import Random from "@frog/source/utility/Random.js"
// const random = new Random()

let UnitSprite = function() {}
import("@frog/source/views/components/UnitSprite.jsx").then((module) => UnitSprite = module.default)
import UnitHealthBar from "@frog/source/views/components/UnitHealthBar.jsx"
import Dice from "@frog/source/data/games/dice/views/Dice.jsx"
import DiceLayout from "@frog/source/data/games/dice/views/DiceLayout.jsx"

import CarryOn from "@frog/source/data/games/dice/scripts/CarryOn.js"
import * as PlotSteps from "@frog/source/data/plot/steps.js"

import "./Modals.less"

function onClickDraft({stage, chest}) {
    return function(event) {
        if(chest?.equipment == undefined) return
        const unit = stage.units[chest.unitKey]
        if(unit == undefined) return
        Object.keys(chest.equipment.items).forEach((key) => {
            const item = chest.equipment.items[key]
            if(item === null) return
            unit.diceFaces[key] = item
        })

        CarryOn(stage)
    }
}

import CHESTS from "@frog/source/data/games/dice/data/chests.js"

const SORTED_CHESTS = {"dog": [], "mouse": [], "frog": []}
Object.values(CHESTS).forEach((chest) => {
    SORTED_CHESTS[chest.unitKey].push(chest)
})

let RANDOMIZED_CHESTS = {}
Object.keys(SORTED_CHESTS).forEach((unitKey) => {
    RANDOMIZED_CHESTS[unitKey] = SORTED_CHESTS[unitKey]
})

export default function LootModal() {
    return [
        {
            "func": function(stage) {
                const chests = []

                const units = Object.values(stage.units).filter((unit) => {
                    if(unit.key == "frog" && stage.currentEncounterKey <= 3) return false
                    return unit.isDead != true
                        && unit.affiliation == stage.player.affiliation
                        && Zone.isInBounds(stage.encounters[stage.currentEncounterKey].zone, unit.position)
                })

                units.forEach((unit) => {
                    if(RANDOMIZED_CHESTS[unit.key] == undefined) return
                    RANDOMIZED_CHESTS[unit.key] = stage.random.shuffle(RANDOMIZED_CHESTS[unit.key])
                    chests.push(RANDOMIZED_CHESTS[unit.key].pop())

                    // if we eat all the content, reshuffle
                    if(RANDOMIZED_CHESTS[unit.key].length == 0) {
                        RANDOMIZED_CHESTS[unit.key] = stage.random.shuffle(SORTED_CHESTS[unit.key])
                    }
                })

                window.generatedChests = chests // TODO AAAAAH IT IS 3:33AM BEFORE THE 7DRL DEADLINE PLEASE FORGIVE ME
            }
        },
        PlotSteps.CustomViewModal({
            "view": (stage) => {
                if(App?.game == undefined) return

                const chests = window.generatedChests // TODO AAAAAH IT IS 3:33AM BEFORE THE 7DRL DEADLINE PLEASE FORGIVE ME
                return (
                    <div class="LootModal">
                        <div class="Header">
                            <div class="BigText">Loot the Room!!</div>
                            <div class="SmallText">Choose a Chest:</div>
                        </div>
                        <section class="UnitsSection">
                            {Object.values(chests).map((chest, index) => {
                                const unit = stage.units[chest.unitKey]
                                if(unit == undefined) return
                                return [
                                    <div class="Unit">
                                        <div class="DraftableDice" draggable={true}>
                                            <div class="Number">Chest #{chest.number}</div>
                                            <div class="Description"><span>{chest.title}</span></div>
                                            <DiceLayout items={chest.equipment.items} unit={unit} stage={stage} anchored={"bottom"}/>
                                        </div>
                                        <div class="Thumbnail">
                                            <UnitSprite unit={unit}/>
                                            <UnitHealthBar unit={unit} maxsegments={20}/>
                                        </div>
                                        <div class="EquippableDice">
                                            <div class="Description">{unit.subtitle} Dice:</div>
                                            <DiceLayout items={unit.diceFaces} unit={unit} stage={stage} anchored={"top"}/>
                                        </div>
                                        <button class="DraftButton" onClick={onClickDraft({stage, chest})}>
                                            <span>Choose Chest!!</span>
                                        </button>
                                    </div>,
                                    index < Object.values(chests).length - 1 ? <div class="Or">or</div> : ""
                                ]
                            })}
                        </section>
                    </div>
                )
            }
        })
    ]
}
